// extracted by mini-css-extract-plugin
module.exports = {"container":"PostDocumentUploader_container__a4Pmy","full-width":"PostDocumentUploader_full-width__4iA_s","icon":"PostDocumentUploader_icon__Jz_NL"};